export default __webpack_public_path__ + "static/media/masthead-en.0693ab4a.png";